import React, {useState, useEffect, useRef, useCallback, createRef} from "react";
import {inject, observer} from 'mobx-react';
import DataGrid, {
    Column,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import {exportDataGrid} from 'devextreme/excel_exporter';
import format from 'date-fns/format';
import {es} from 'date-fns/locale';
import axios from "axios";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import HeaderPage from "../../../../palette/HeaderPage";
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import Alerts from "../../../../palette/Alerts";
import Load from "../../../../palette/Load";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

const url = 'https://ratings-easi4xatjq-uc.a.run.app/ratings'
//const url = 'http://127.0.0.1:5000/ratings'

function Ratings(props) {

    const {DataStore} = props;

    const {companyName, idCompany} = DataStore

    const [ratings, setRatings] = useState(null)
    const [loading, setLoading] = useState(true)
    const [textGrid, setTextGrid] = useState('Esperando datos...');
    const [generalRatings, setGeneralRatings] = useState(null)
    const [generalRatingsStr, setGeneralRatingsStr] = useState(null)
    const [textLoad, setTextLoad] = useState('Cargando datos')

    const isMounted = useMountedState()
    const dataGridRef = createRef();

    setTimeout(() => setTextLoad('Espere un momento . . .'), 3000)

    useEffect(() => {
        const GetRatings = async () => {
            setLoading(false)
            const year = format(new Date(), 'yyyy')
            const month = format(new Date(), 'MMMM', {locale: es})

            const data = {companyName, idCompany, year, month}

            await axios.post(url, data, {headers: headers})
                .then(res => {
                    setRatings(res.data.ratings)
                    res.data.ratings.length === 0 && setTextGrid('No existen datos disponibles por el momento')
                    setGeneralRatings(res.data.generalMean)
                    setGeneralRatingsStr(res.data.generalMeanStr)
                    setLoading(true)
                    setTextLoad('Cargando datos')
                })
        }
        if (isMounted()) {
            GetRatings().catch(() => {})
        }

    }, [isMounted])

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF('l', 'pt', "a4");
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 60, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Calificación de conductore`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 15, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 30, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 45, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Calificación-conductore.pdf');
        });
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'},
                        };
                    }
                }
            },
        }).then(function () {
            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Calificación de conductore`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'};

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'};

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Calificación-conductore.xlsx');
            });
        });
        e.cancel = true;
    };

    return (
        <>
            <VerticalSpace space={30}/>
            {ratings?.length > 0 &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <div className="grid-container">
                    <HeaderPage icon={'fas fa-star-half-alt'} text={'Calificaion de conductores'} load={loading}
                                textLoad={'Cargando....'}/>
                    <FormContainer>
                        <DataGrid
                            id="types-vehicles"
                            dataSource={ratings}
                            ref={dataGridRef}
                            keyExpr="ID"
                            allowColumnReordering={true}
                            showBorders={true}
                            onToolbarPreparing={onToolbarPreparing}
                            rowAlternationEnabled={true}
                            noDataText={textGrid}
                            onExporting={onExporting}
                        >
                            <SearchPanel visible={true}
                                         width={240}
                                         placeholder="Buscar"/>
                            <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                            <Sorting mode="multiple"/>
                            <Paging defaultPageSize={20}/>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 30]}
                                showInfo={true}/>
                            <Column dataField="driver" alignment={'center'} caption={'Conductor'}/>
                            <Column dataField="ratingsValue" alignment={'center'} caption={'Promedio general'}/>
                            <Column dataField="ratingStr" alignment={'center'} caption={'Calificación cualitativa'}/>

                            <Summary>
                                <TotalItem
                                    /*column="ratingsValue"
                                    summaryType="avg"*/
                                    showInColumn="ratingsValue"
                                    displayFormat={`${generalRatings}`}
                                />

                                <TotalItem
                                    showInColumn="ratingStr"
                                    displayFormat={`${generalRatingsStr}`}
                                />
                            </Summary>
                        </DataGrid>
                    </FormContainer>
                </div>
            </Animated>}
            {ratings?.length === 0 &&
            <LayoutChild percent={95} margin="auto">
                <Alerts severity='warning' body={'No existen datos disponibles por le momento'}/>
            </LayoutChild>
            }
            {ratings === null &&
            <div>
                <Load textLoad={textLoad}/>
            </div>
            }
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(Ratings));

const styles = {
    divContainer: {
        padding: 10,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        background: '#607D8B',
        borderRadius: 5,
        marginTop: 10
    },

    textStyle: {
        fontWeight: 'bold',
        fontSize: 14,
        color: '#FFF',
    }
}

